import Trix from 'trix';
import "./trix/alignment_elements";

// Trix 2.1.4+ added a built-in HTMLSanitizer that forbids iframe elements and
// strips non-standard attributes, plus DOMPurify sanitization on top.
// Embeds rely on iframes and data-clipboard-* attributes for the copy URL feature.
const EMBED_ALLOWED_ATTRIBUTES = [
  // Trix HTMLSanitizer defaults (must be preserved or all content breaks)
  'style', 'href', 'src', 'width', 'height', 'language', 'class',
  // Iframe attributes for embed previews (YouTube, Vimeo, etc.)
  'sandbox', 'allow', 'allowfullscreen', 'frameborder',
  'mozallowfullscreen', 'webkitallowfullscreen', 'credentialless',
  // General HTML attributes used in embed content
  'title', 'alt',
  // Copy URL button on embeds (see Embed.append_copy_url_button)
  'data-clipboard-action', 'data-clipboard-url', 'data-clipboard-title'
];

const originalSetHTML = Trix.HTMLSanitizer.setHTML;

Trix.HTMLSanitizer.setHTML = function(element, html, options = {}) {
  if (!options.forbiddenElements) {
    options.forbiddenElements = ["script", "form", "noscript"];
  }

  if (!options.allowedAttributes) {
    options.allowedAttributes = EMBED_ALLOWED_ATTRIBUTES;
  }

  return originalSetHTML.call(this, element, html, options);
};

Trix.config.dompurify.ADD_TAGS = [
  ...(Trix.config.dompurify.ADD_TAGS || []),
  'iframe',
  'align-left', 'align-center', 'align-right'
];

Trix.config.dompurify.ADD_ATTR = [
  ...Trix.config.dompurify.ADD_ATTR,
  ...EMBED_ALLOWED_ATTRIBUTES
];

Trix.Attachment.previewablePattern = /^image(\/(gif|png|jpe?g|heic|heif)|$)/;

Array.from(['heading1', 'heading2', 'heading3']).forEach((attr, index) => {
  Trix.config.blockAttributes[attr] = {
    tagName: `h${(index + 1)}`,
    group: false,
    nestable: false,
    terminal: false,
    breakOnReturn: true
  }
});

Array.from(['Left', 'Right', 'Center']).forEach((tagName) => {
  Trix.config.blockAttributes[`align${tagName}`] = {
    tagName: `align-${tagName.toLowerCase()}`,
    nestable: false,
    exclusive: true,
  }
});
